<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row  mt-2">



                    <div class="col-md-2 " v-if="authenticatedUser.permissions.includes('super') ">
                        <b-link class="" :to="{ path: '/task-form',query: { type: 'add'} }">
                            <b-button class="btn-info mb-2" > Add Task </b-button>
                        </b-link>
                    </div>

                    <!--                    <div class="col-md-2">-->
                    <!--                        <b-input v-model="claimfilters.order_id"-->
                    <!--                                 @input="()=>{-->
                    <!--                                 this.claimfilters.page=1;-->
                    <!--                                 this.get_claims()-->
                    <!--                              }"-->
                    <!--                                 placeholder="Order ID"></b-input>-->
                    <!--                    </div>-->
                    <!--                    <div class="col-md-2">-->
                    <!--                        <b-input v-model="claimfilters.customer_name"-->
                    <!--                                 @input="()=>{-->
                    <!--                                 this.claimfilters.page=1;-->
                    <!--                                 this.get_claims()-->
                    <!--                              }"-->
                    <!--                                 placeholder="Name"></b-input>-->
                    <!--                    </div>-->
                    <!--                    <div class="col-md-2">-->
                    <!--                        <b-input v-model="claimfilters.phone_number"-->
                    <!--                                 @input="()=>{-->
                    <!--                                 this.claimfilters.page=1;-->
                    <!--                                 this.get_claims()-->
                    <!--                              }"-->
                    <!--                                 placeholder="Mobile"></b-input>-->
                    <!--                    </div>-->


                    <div class="col-md-2" v-if="authenticatedUser.permissions.includes('super')">
                        <v-select
                            v-model="branch_task_filters.branch_id"
                            @input="()=>{
                                 this.branch_task_filters.page=1;
                                 this.get_tasks()
                              }"
                            class="text-dark"
                            placeholder="Branch"
                            :options="branches"

                            label="name"
                            :reduce="option => option.id"

                        />
                    </div>
                    <!--                    <div class="col-md-2">-->
                    <!--                        <v-select-->
                    <!--                            v-model="branch_task_filters.status"-->
                    <!--                            @input="()=>{-->
                    <!--                                 this.branch_task_filters.page=1;-->
                    <!--                                 this.get_tasks()-->
                    <!--                              }"-->
                    <!--                            class="text-dark"-->
                    <!--                            placeholder="Status"-->
                    <!--                            :options="['Pending','Approved','Completed']"-->

                    <!--                        />-->
                    <!--                    </div>-->





                    <!--                    <b-table id="customers-table"  class="bg-light" :items="filteredCustomers" :fields="fields" striped hover responsive :per-page="perPage" :current-page="currentPage">-->


                    <!--                        <template #cell(actions)="data">-->

                    <!--                            <b-link class="" :to="{ path: '/customerform',query: { type: 'edit', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > Edit </b-button>-->
                    <!--                            </b-link>-->
                    <!--                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > View </b-button>-->
                    <!--                            </b-link>-->
                    <!--&lt;!&ndash;                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">&ndash;&gt;-->
                    <!--&lt;!&ndash;                                <b-button class="btn-info mb-2" > Orders </b-button>&ndash;&gt;-->
                    <!--&lt;!&ndash;                            </b-link>&ndash;&gt;-->

                    <!--                        </template>-->

                    <!--                    </b-table>-->
                    <!--                    <b-pagination-->
                    <!--                        class=""-->
                    <!--                        v-model="currentPage"-->
                    <!--                        :total-rows="customers.length"-->
                    <!--                        :per-page="perPage"-->
                    <!--                        aria-controls="customers-table"-->
                    <!--                    ></b-pagination>-->
                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                        <!--                        <button class="btn-sm btn-info" @click="getinvoices">-->
                        <!--                            <span v-if="showloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
                        <!--                            Refresh-->
                        <!--                        </button>-->
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="tasks?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="tasks?.to-50>0">{{tasks?.to-50}}</span> <span v-else="">0</span>  to {{tasks.to}}) out of {{tasks.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="tasks?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                    <!--                    <div class="col-md-2 text-right">-->
                    <!--                        <button class="btn-sm btn-warning"    @click="clearfilters" >Clear Filters</button>-->
                    <!--                    </div>-->

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-bordered table-striped text-light">
                        <thead class="thead-dark">
                        <tr>

                            <th>ID</th>
                            <th>Due Date</th>
                            <th>Branch</th>

                            <th>Description</th>
                            <th>Submitted At</th>
                            <th>Submitted By</th>
                            <th>Image</th>


                            <th>Status</th>





                            <th class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody >
                        <template v-for="task in tasks.data">
                            <tr :class="((task.priority === 'Urgent' || new Date(task.due_date) < new Date())&&task.status!=='Completed')?'bg-danger':''">
                                <td>{{task.id}}</td>
                                <td v-if="task.priority!=='Urgent'"><span v-if="task.due_date">{{formatDate(task.due_date)}}</span></td>
                                <td v-else>Urgent</td>
                                <td v-if="task.branch">{{task.branch.name}}</td>
                                <td v-else >Anyone</td>
                                <td>{{task.description}}</td>
                                <td> <span v-if="task.submitted_at">{{formatDate(task.submitted_at)}}</span></td>
                                <td ><span v-if="task.submitted_by_user">{{task.submitted_by_user.first_name}} {{task.submitted_by_user.last_name}}</span></td>
                                <td><a :href="task.submitted_file" target="_blank"><img height="50px" :src="task.submitted_file" /></a></td>
                                <td>{{task.status}}</td>
                                <td class="text-center">

                                    <b-button @click="approve_task(task.id)" v-if="authenticatedUser.permissions.includes('super') && task.status==='Submitted'" :disabled="saving" class="btn-success mx-1 "> Approve </b-button>
                                    <b-button @click="submit_task(task.id)" v-if="task.status==='Pending' && !authenticatedUser.permissions.includes('super')" :disabled="saving" class="btn-warning  "> Submit </b-button>
                                    <b-link class="mx-1" :to="{ path: '/task-form',query: { type: 'edit', 'id': task.id } }"  v-if="(authenticatedUser.permissions.includes('super') && task.status=='Pending') ">
                                        <b-button class="btn-info " > Edit </b-button>
                                    </b-link>
                                    <b-button @click="deletetask(task.id)" v-if="(authenticatedUser.permissions.includes('super') && task.status!='Completed') " :disabled="saving" class="btn-danger "> Delete </b-button>

                                </td>
                            </tr>
                        </template>

                        </tbody>
                    </table>
                </div>



            </div>

        </div>

    </div>

</template>

<script>
//import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import vSelect from "vue-select";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import moment from "moment/moment";
//import vSelect from "vue-select";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import apiService from "@/service/apiService";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from "lodash";


export default {
    name: "branch targets",

    components:{Loader, Welcomenote, 'v-select': vSelect,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('branch_tasks',['branch_task_filters','tasks']),
        //  ...mapState('customers', ['customers']), not using this state
        ...mapState('invoice', ['branches']),
        totalPages() {
            const perpage = this.tasks.per_page;
            const total=this.tasks.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },


    },
    data() {
        return {
            saving:false,
            // RTO_URL:'http://127.0.0.1:8185',
            RTO_URL:'https://righttiles.co.uk',
            OTO_URL:'http://127.0.0.1:8186',
            roles: [],
            user: {},
            // perPage:100,
            // currentPage: 1,

            showloader:false,


            // cashier_id:'',
            // order_status:'',
            // branch_id:'',
            // searchcustname:'',
            // searchcustphone:'',
            // searchcustemail:'',
            // custtype:'',
            // credit:true,

            // fields: [
            //
            //     { key: 'lastName', label: 'Name' },
            //     { key: 'mobile', label: 'Mobile' },
            //     { key: 'customerType', label: 'Customer Type' },
            //     { key: 'email', label: 'Email' },
            //     { key: 'walletBalance', label: 'Balance' },
            //     'actions'
            //
            // ],

        };
    },
    async created() {
        //  await this.getUsers();
        //   await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()

        const promises = [

            this.reloadcb(),
            this.get_tasks(),

        ];
        this.showloader=true
        await Promise.all(promises);
        this.showloader=false

    },
    async mounted() {
        Fancybox.bind("[data-fancybox]", {});




    },
    updated() {

        Fancybox.bind("[data-fancybox]", {});
    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),
        ...mapActions('branch_tasks', ['set_tasks','get_tasks']),

        async submit_task(id) {
            const { value: formValues, isConfirmed } = await Swal.fire({
                title: 'Submit Task',
                html: `
            <p>This action cannot be undone.</p>
            <input type="file" id="taskFile" class="" />
        `,
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'Cancel',
                focusConfirm: false,
                preConfirm: () => {
                    const fileInput = document.getElementById('taskFile');
                    if (!fileInput.files.length) {
                        Swal.showValidationMessage('Please select a file to upload.');
                        return false;
                    }
                    return fileInput.files[0];
                }
            });

            if (isConfirmed && formValues) {
                const file = formValues;

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }

                try {
                    this.saving = true;

                    const formData = new FormData();
                    formData.append('file', file);

                    const res = await axios.post(`${URL.BASEURL}/api/submit-task/${id}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (res && res.data) {
                        Swal.fire('Success', 'Task Submitted ', 'success');
                        await this.get_tasks();
                    } else {
                        Swal.fire('Info', 'Task Could Not Be Submitted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to Submit Task', 'error');
                } finally {
                    this.saving = false;
                }
            }
        },


        async approve_task(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to approve this task?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.post(`${URL.BASEURL}/api/approve-task/${id}`);

                    if (res) {

                        // this.claims.data= this.claims.data.map((c)=>{
                        //    if(c.id===res.id) {
                        //        return res
                        //    } else {
                        //        return c
                        //    }
                        // })

                        Swal.fire('success', 'Task Approved', 'success');
                        await  this.get_tasks()

                    } else {
                        Swal.fire('info', 'Task Cant be Approved', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to Approve Task.', 'info');
                }
                this.saving=false
            }

        },


        async deletetask(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this task?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-task/${id}`);

                    if (res) {
                        let tasks=cloneDeep(this.tasks)
                        tasks.data=this.tasks.data.filter((c)=>c.id!==id)
                         await this.set_tasks(tasks)

                        Swal.fire('success', 'Task  Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Task Cant be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete Task.', 'info');
                }
                this.saving=false
            }

        },




        formatDate(date){
            let date1 = new Date(date)
            let date2 = moment(date1).format('D MMMM, YYYY');

            return date2;
        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },


        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }

        },

        async get_paged_data(button){
            let current_page= this.tasks.current_page
            this.branch_task_filters.page=current_page



            if(button=='next'){

                this.branch_task_filters.page=current_page+1

                await   this.get_tasks()

            }
            if(button=='prev'){
                this.branch_task_filters.page=current_page-1

                await  this.get_tasks()


            }

        },


    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}



</style>
